module.exports = __webpack_public_path__ + "img/Gardeshgari.2bfd58d4.svg";